import { ShoppingBag, MapPin } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { Link } from "react-router-dom";

export default function Navbar() {
  const { totals, setIsOpen } = useCart();

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-40 backdrop-blur-md bg-[#F9F6F0]/85 border-b border-[#E5D9C5]"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
        <Link to="/" data-testid="brand-home-link" className="flex items-center gap-2 group">
          <img
            src="https://customer-assets-v7afamib.emergentagent.net/job_guam-kitchen-orders/artifacts/y8p47pey_33E5A0BF-FB4B-402C-8826-2BFAE9A52156.png"
            alt="Hafa Adai Kitchen"
            className="w-11 h-11 sm:w-12 sm:h-12 object-contain drop-shadow-sm"
          />
          <div className="leading-tight">
            <div className="font-display font-extrabold text-[#2C241B] text-lg">Hafa Adai Kitchen</div>
            <div className="text-[11px] text-[#7A6C5D] hidden sm:flex items-center gap-1">
              <MapPin className="w-3 h-3" /> Laveen, AZ
            </div>
          </div>
        </Link>

        <button
          data-testid="nav-open-cart-btn"
          onClick={() => setIsOpen(true)}
          className="relative flex items-center gap-2 rounded-full bg-white border border-[#E5D9C5] px-4 py-2 hover:bg-[#F5EEE0] transition-colors"
        >
          <ShoppingBag className="w-5 h-5 text-[#2C241B]" />
          <span className="font-semibold text-sm text-[#2C241B]">Cart</span>
          {totals.count > 0 && (
            <span
              data-testid="cart-badge-count"
              className="ml-1 inline-flex items-center justify-center min-w-[22px] h-[22px] px-1.5 rounded-full bg-[#D9381E] text-[#FFF6EA] text-xs font-bold"
            >
              {totals.count}
            </span>
          )}
        </button>
      </div>
    </header>
  );
}
